import { HorizontalContainer, Spinner } from '@/components';

export const SpinnerContainer = () => {
    return (
        <HorizontalContainer className="justify-center py-4">
            <Spinner />
        </HorizontalContainer>
    );
};
